import { CurrencyEnum } from '@systemeio/ui'
import { LanguageCodeEnum } from 'shared/enums/language-code-enum'

export const getCurrencySymbol = (currency: CurrencyEnum, intlLocale: LanguageCodeEnum) =>
  (0)
    .toLocaleString(intlLocale, {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
    .replace(/\d/g, '')
    .trim()
